import React from 'react'
import { StyledBadge } from './styled'
import { BadgeProps } from './types'

export const Badge: React.FC<BadgeProps> = (props: BadgeProps) => {
  return <StyledBadge {...props}>{props.children}</StyledBadge>
}
